import React, {FC, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Paper, PaperProps} from "@mui/material";
import Button from "@mui/material/Button";
import {PDFViewer} from "@react-pdf/renderer";
import LogShipmentReportPdf from "./LogShipmentReportPdf.tsx";
import {PictureAsPdf} from "@mui/icons-material";
import {Shipment} from "../../../types/models/Shipment.ts";
import {PrimaryBuyer} from "../../../types/models/Buyer.ts";
import {useGetCuttingQuery} from "../../../apis/Cutting.api.ts";
import {PrimaryCutting} from "../../../types/models/Cutting.ts";
import {useGetBuyerQuery} from "../../../apis/Buyer.api.ts";
import {useGetLocationQuery} from "../../../../location/apis/Location.api.ts";
import {PrimaryLocation} from "../../../../location/types/models/Location.ts";
import {useGetProviderQuery} from "../../../apis/Provider.api.ts";
import {PrimaryProvider} from "../../../types/models/Provider.ts";
import {useGetTimberStorageQuery} from "../../../apis/TimberStorage.api.ts";
import {PrimaryTimberStorage} from "../../../types/models/TimberStorage.ts";
import {WoodGroupsList} from "../../../types/models/MergeGroups.ts";
import { Trans } from "@lingui/react/macro";

function PaperComponent(props: PaperProps) {
    return (
        <Paper {...props} />
    );
}

type IShipmentReportDialogProps = {
    shipment: Shipment;
    groupedData: WoodGroupsList;
    copies?: number;
};

const LogShipmentReportPdfDialog: FC<IShipmentReportDialogProps> = ({groupedData, shipment, copies = 1}) => {

    const [open, setOpen] = useState(false);

    const {data: cutting} = useGetCuttingQuery(PrimaryCutting.fromId(shipment.cuttingId), {skip: !open})
    const {data: storage} = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(shipment.storageId), {skip: !open})
    const {data: storageLocation} = useGetLocationQuery(PrimaryLocation.fromId(storage?.locationId), {skip: !storage?.locationId || !open})
    const {data: sourceLocation} = useGetLocationQuery(PrimaryLocation.fromId(shipment.sourceLocationId), {skip: !shipment.sourceLocationId || !open})
    const {data: provider} = useGetProviderQuery(PrimaryProvider.fromId(cutting?.providerId), {skip: !open || !cutting?.providerId})
    const {data: buyer} = useGetBuyerQuery(PrimaryBuyer.fromId(shipment.buyerId), {skip: !shipment.buyerId || !open})
    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button onClick={handleClickOpen}><PictureAsPdf/></Button>
            <Dialog open={open && groupedData} onClose={handleClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" slotProps={{ paper: {
                    style: {
                        width: '70%',       // Custom width
                        height: '850px'     // Custom height
                    },
                } }}>
                <DialogTitle>{shipment.key}</DialogTitle>
                <DialogContent>
                        <div>
                            <PDFViewer showToolbar={true} width="100%" height="700px">
                                <LogShipmentReportPdf 
                                    shipment={shipment}
                                    sourceLocation={sourceLocation || storageLocation}
                                    buyer={buyer}
                                    provider={provider}
                                    groupedData={groupedData}
                                    numberOfCopies={copies}
                                />
                            </PDFViewer>
                        </div>
                </DialogContent>
                <DialogActions>
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'row' }}>
                        <Trans>Number of copies</Trans>: {copies}
                    </Paper>
                    <Button onClick={handleClose} color="primary">
                        <Trans>Close</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default LogShipmentReportPdfDialog
